export default function PDFJS($window) {
    'ngInject';

    return {
        getDocument: (...args) => $window.PDFJS.getDocument.apply($window.PDFJS, args),
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/wrappers/PDFJS.js